export default __webpack_public_path__ + "static/media/auraofdreadfury.81375fd8.png";